export default __webpack_public_path__ + "static/media/bewerber-section-phone.2ba84b64.png";